import { BaseEntity } from "./BaseEntity";
import { Internship } from "./Internship";
import { InternshipScheduleSeat } from "./InternshipScheduleSeat";
import { TrainingYear } from "./TrainingYear";

export type WeekDays = Record<string, boolean>;

export type TimeSlot = {
    date: Date | string | null;
    day: string;
    startTime: Date | string | null;
    endTime: Date | string | null;
    breakDuration: number;
    isChecked: boolean;
};

export type TimeSlots = TimeSlot[][];

export class InternshipSchedule extends BaseEntity {
    public name: string = "";
    public capacity: number = 0;
    public startDate: Date | null | string = "";
    public endDate: Date | null | string = "";
    public startTime: Date | null | string = "";
    public endTime: Date | null | string = "";
    public breakDuration: number = 0;
    public totalUsedSeats?: number = 0;
    public weekDays: WeekDays = {
        mon: true,
        tue: true,
        wed: true,
        thu: true,
        fri: true,
        sat: false,
        sun: false,
    };
    public timeSlots: TimeSlots = [];
    public isScheduleDetail: boolean = false;
    public internship: string | Internship = "";
    public isBreakInclude: boolean = false;
    public totalTime: number = 0;
    public trainingYear: string | TrainingYear = "";
    public internshipScheduleSeats?: string[] | InternshipScheduleSeat[] = [];

    constructor(model: Partial<InternshipSchedule> = {}) {
        super(model?.id);
        Object.assign(this, model);
    }
}

export type PInternshipSchedule = Partial<InternshipSchedule>;
